"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _createLanguageOption = _interopRequireDefault(require("./createLanguageOption"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    icon: {
      color: function color(props) {
        return props.color;
      }
    },
    root: {
      color: function color(props) {
        return props.color;
      }
    }
  };
});

var LanguageSelect = function LanguageSelect(props) {
  var classes = useStyles(props);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      labelWidth = _useState2[0],
      setLabelWidth = _useState2[1];

  var inputLabel = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    return setLabelWidth(inputLabel && inputLabel.current && inputLabel.current.offsetWidth);
  }, []);
  return _react.default.createElement(_core.FormControl, {
    variant: props.variant
  }, props.noLabel ? null : _react.default.createElement(_core.InputLabel, {
    ref: inputLabel
  }, props.label), _react.default.createElement(_core.Select, {
    classes: classes,
    value: props.value,
    onChange: props.onChange,
    labelWidth: labelWidth,
    disableUnderline: true
  }, props.languages && props.languages.map && props.languages.map(function (_ref) {
    var code = _ref.code,
        name = _ref.name;
    return (0, _createLanguageOption.default)(code, name);
  })));
};

LanguageSelect.defaultProps = {
  noLabel: false,
  variant: 'standard',
  label: 'Languages',
  color: '#000000'
};
LanguageSelect.propTypes = {
  noLabel: _propTypes.default.bool,
  color: _propTypes.default.string,
  label: _propTypes.default.string,
  variant: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  languages: _propTypes.default.array.isRequired
};
var _default = LanguageSelect;
exports.default = _default;